import { Injectable, NgModule } from '@angular/core';
import {
  PreloadingStrategy,
  Route,
  RouterModule,
  Routes,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { GoogleFontResolver } from './resolvers/google-font.resolver';
import { HomeComponent } from './pages/home/home.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';

@Injectable({
  providedIn: 'root',
})
export class CustomPreloadingStrategy implements PreloadingStrategy {
  preload(route: Route, load: () => Observable<any>): Observable<any> {
    return route.data?.['preload'] ? load() : of(null);
  }
}

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
  },
  {
    path: 'aboutus',
    data: { preload: true },
    loadChildren: () =>
      import('./modules/lazy-loaded/about-us.module').then(
        (m) => m.AboutUsModule
      ),
  },
  {
    path: 'services',
    data: { preload: true },
    loadChildren: () =>
      import('./modules/lazy-loaded/services.module').then(
        (m) => m.ServicesModule
      ),
  },
  {
    path: 'department/:slug',
    data: { preload: true },
    loadChildren: () =>
      import('./modules/lazy-loaded/department-detail.module').then(
        (m) => m.DepartmentDetailModule
      ),
  },
  {
    path: 'dashboard',
    data: { preload: true },
    loadChildren: () =>
      import('./modules/lazy-loaded/dashboard.module').then(
        (m) => m.DashboardModule
      ),
  },
  {
    path: 'partners',
    data: { preload: true },
    loadChildren: () =>
      import('./modules/lazy-loaded/our-partners.module').then(
        (m) => m.OurPartnersModule
      ),
  },
  {
    path: 'partner-departments',
    data: { preload: true },
    loadChildren: () =>
      import('./modules/lazy-loaded/partner-depts.module').then(
        (m) => m.PartnerDeptsModule
      ),
  },
  {
    path: 'partner-assistive',
    data: { preload: false },
    loadChildren: () =>
      import('./modules/lazy-loaded/assistive-mode.module').then(
        (m) => m.AssistiveModeModule
      ),
  },
  {
    path: 'video_presentation',
    data: { preload: false },
    loadChildren: () =>
      import('./modules/lazy-loaded/video-presentation.module').then(
        (m) => m.VideoPresentationModule
      ),
  },
  {
    path: 'careers',
    data: { preload: false },
    loadChildren: () =>
      import('./modules/lazy-loaded/careers.module').then(
        (m) => m.CareersModule
      ),
  },
  {
    path: 'scheme',
    data: { preload: false },
    resolve: { googleFont: GoogleFontResolver },
    loadChildren: () =>
      import('./modules/myscheme/myscheme.module').then(
        (m) => m.MySchemeModule
      ),
  },

  {
    path: 'search',
    data: { preload: true },
    resolve: { googleFont: GoogleFontResolver },
    loadChildren: () =>
      import('./modules/lazy-loaded/global-search.module').then(
        (m) => m.GlobalSearchModule
      ),
  },
  {
    path: 'accessibility',
    data: { preload: false },
    loadChildren: () =>
      import('./modules/lazy-loaded/isl-chatbot.module').then(
        (m) => m.IslChatbotModule
      ),
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top',
      initialNavigation: 'enabledBlocking',
      preloadingStrategy: CustomPreloadingStrategy,
      onSameUrlNavigation:'reload'
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
